import { render, staticRenderFns } from "./LbaObjectHasPermissions.vue?vue&type=template&id=25090622"
import script from "./LbaObjectHasPermissions.vue?vue&type=script&lang=js"
export * from "./LbaObjectHasPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports